import React, {createContext, useEffect, useState} from 'react';
import {
    Routes,
    Route,
    Navigate,
    useLocation
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { SeoProvider } from './context/SeoContext';
import HomePage from "./pages/HomePage";
import Menu from "./components/Menu/Menu";
import Footer from "./components/Footer/Footer";
import HotelsPage from "./pages/HotelsPage";
import Tours from "./pages/Tours";
import Packages from "./pages/Packages";
import Abroad from "./pages/Abroad";
import Restaurant from "./pages/Restaurant";
import EmbassyPage from "./pages/EmbassyPage";
import AboutArmenia from "./pages/AboutArmenia";
import TourPage from "./pages/TourPage";
import GroupToursPage from "./pages/GroupToursPage";
import GroupTourPage from "./pages/GroupTourPage";
import TourPackagePage from "./pages/TourPackagePage";
import AbroadPage from "./pages/AbroadPage";
import OtherTour from "./pages/OtherTour";
import OtherToursPage from "./pages/OtherToursPage";
import AboutArmeniaSingle from "./pages/AboutArmeniaSingle";
import HotelSingle from "./pages/HotelSingle";
import Apartment from "./pages/Apartment";
import ApartmentSingle from "./pages/ApartmentSingle";
import RestaurantSingle from "./pages/RestaurantSingle";
import EmbassySingle from "./pages/EmbassySingle";
import News from "./pages/News";
import NewsSingle from "./pages/NewsSingle";
import GuideBook from "./pages/GuideBook";
import GuideSingle from "./pages/GuideSingle";
import BookingPage from "./pages/BookingPage";
import AboutUs from "./pages/AboutUs";
export const LangContext = createContext('en')
export const ChangeLangContext = createContext('')
const App = () => {
    const [lang,setLang] = useState('en')
    const location = useLocation();

    useEffect(() => {
        const first = location.pathname.split('/').filter(Boolean)[0];
        if (['en','de','ru'].includes(first)) {
            if (first !== lang) setLang(first);
        }
    }, [location.pathname]);

    return (
       <HelmetProvider>
            <LangContext.Provider value={lang}>
            <ChangeLangContext.Provider value={setLang}>
                <SeoProvider>
                    <Menu/>
                    <Routes>
                        {/* Redirect bare root to current lang */}
                        <Route path='/' element={<Navigate to={`/${lang}`} replace />} />
                        <Route path='/about' element={<AboutUs to={`/${lang}/about`} />} />

                        {/* Legacy routes without language prefix (kept for backward compatibility) */}
                        <Route path='/private-tours' element={<Tours/>} />
                        <Route path='/group-tours' element={<GroupToursPage/>} />
                        <Route path='/private-tour/:id/:slug?' element={<TourPage/>} />
                        <Route path='/group-tour/:id/:slug?' element={<GroupTourPage/>} />
                        <Route path='/other-tour/:id/:slug?' element={<OtherTour/>} />
                        <Route path='/other-tours' element={<OtherToursPage/>} />
                        <Route path='/packages' element={<Packages/>} />
                        <Route path='/tour-package/:id/:slug?' element={<TourPackagePage/>} />
                        <Route path='/abroad' element={<Abroad/>} />
                        <Route path='/abroad/:id/:slug?' element={<AbroadPage/>} />
                        <Route path='/embassies' element={<EmbassyPage/>} />
                        <Route path='/embassy-page/:id/:slug?' element={<EmbassySingle/>} />

                        <Route path='/hotels' element={<HotelsPage/>} />
                        <Route path='/hotels-page/:id/:slug?' element={<HotelSingle/>} />
                        <Route path='/restaurants' element={<Restaurant/>} />
                        <Route path='/restaurant-page/:id/:slug?' element={ <RestaurantSingle/> } />
                        <Route path='/about-armenia' element={<AboutArmenia/>} />
                        <Route path='/armenia/:id/:slug?' element={<AboutArmeniaSingle/>} />
                        <Route path='/apartment' element={<Apartment/>} />
                        <Route path='/apartment-page/:id/:slug?' element={<ApartmentSingle/>} />
                        <Route path='/news' element={<News/>} />
                        <Route path='/news/:id/:slug?' element={<NewsSingle/>} />
                        <Route path='/guide' element={<GuideBook/>} />
                        <Route path='/guide/:id/:slug?' element={<GuideSingle/>} />
                        <Route path='/booking/:type/:id/:date/:price/:people/:children/:langFrom/:startingTime' element={<BookingPage/>} />

                        {/* Language-prefixed routes */}
                        <Route path='/:lang'>
                            <Route index element={<HomePage/>} />
                            <Route path='private-tours' element={<Tours/>} />
                            <Route path='group-tours' element={<GroupToursPage/>} />
                            <Route path='private-tour/:id/:slug?' element={<TourPage/>} />
                            <Route path='group-tour/:id/:slug?' element={<GroupTourPage/>} />
                            <Route path='other-tour/:id/:slug?' element={<OtherTour/>} />
                            <Route path='other-tours' element={<OtherToursPage/>} />
                            <Route path='packages' element={<Packages/>} />
                            <Route path='tour-package/:id/:slug?' element={<TourPackagePage/>} />
                            <Route path='abroad' element={<Abroad/>} />
                            <Route path='abroad/:id/:slug?' element={<AbroadPage/>} />
                            <Route path='embassies' element={<EmbassyPage/>} />
                            <Route path='embassy-page/:id/:slug?' element={<EmbassySingle/>} />

                            <Route path='hotels' element={<HotelsPage/>} />
                            <Route path='hotels-page/:id/:slug?' element={<HotelSingle/>} />
                            <Route path='restaurants' element={<Restaurant/>} />
                            <Route path='restaurant-page/:id/:slug?' element={ <RestaurantSingle/> } />
                            <Route path='about-armenia' element={<AboutArmenia/>} />
                            <Route path='armenia/:id/:slug?' element={<AboutArmeniaSingle/>} />
                            <Route path='apartment' element={<Apartment/>} />
                            <Route path='apartment-page/:id/:slug?' element={<ApartmentSingle/>} />
                            <Route path='news' element={<News/>} />
                            <Route path='news/:id/:slug?' element={<NewsSingle/>} />
                            <Route path='guide' element={<GuideBook/>} />
                            <Route path='guide/:id/:slug?' element={<GuideSingle/>} />
                            <Route path='booking/:type/:id/:date/:price/:people/:children/:langFrom/:startingTime' element={<BookingPage/>} />
                            <Route path='about' element={<AboutUs to={`/${lang}/about`} />} />
                        </Route>
                    </Routes>
                    <Footer/>
                </SeoProvider>
            </ChangeLangContext.Provider>
            </LangContext.Provider>
       </HelmetProvider>
    );
};

export default App;